const checkIsInteger = (num) => (num ^ 0) === num;

export default checkIsInteger;
